import { render, staticRenderFns } from "./updateOrCreatePlaceUser.vue?vue&type=template&id=28633b5a"
import script from "./updateOrCreatePlaceUser.vue?vue&type=script&lang=js"
export * from "./updateOrCreatePlaceUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports